import type { QuestionSectionKind } from '@/features/content/editor/editorTypes';

import type { NormalizedQuestionData } from './questionNormalizer';

function relabelQuestion(
  question: NormalizedQuestionData,
  label: string,
): NormalizedQuestionData {
  return {
    ...question,
    label,
  };
}

/**
 * The questions a section draws, and what it calls them. A question removed
 * from the assignment is never drawn, in any mode, and the rest are numbered
 * without it. It stays in the list this is handed, at its position, because the
 * student save sends question stats by position.
 */
export function getDisplayedQuestions(
  questions: NormalizedQuestionData[],
  kind: QuestionSectionKind,
) {
  return {
    assigned: questions
      .filter((question) => question.isAssigned && !question.isRemoved)
      .map((question, index) =>
        relabelQuestion(
          question,
          kind === 'preLecture'
            ? `Pre-Lecture Question ${index + 1}`
            : `Question ${index + 1}`,
        ),
      ),
    practice: questions
      .filter((question) => !question.isAssigned && !question.isRemoved)
      .map((question, index) => relabelQuestion(question, `Practice ${index + 1}`)),
  };
}
